import { render, staticRenderFns } from "./HomeTelegramComponent.vue?vue&type=template&id=601bc904"
import script from "./HomeTelegramComponent.vue?vue&type=script&lang=js"
export * from "./HomeTelegramComponent.vue?vue&type=script&lang=js"
import style0 from "./HomeTelegramComponent.vue?vue&type=style&index=0&id=601bc904&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports